import React, { useState, useEffect } from 'react';
import './select.css';

const Select = props => {
    const [activeType, setActiveType] = useState({});
    const [isOpen, setIsOpen] = useState(false);
    const selectRef = React.useRef();
    const [defaultTitle, setDefaultTitle] = useState('');
    const types = [
        {title: 'Обычный', id: 1},
        {title: 'Какой ты ?', id: 2}
    ];

    const setType = (e, id) => {
        e.preventDefault();
        const selectedType = types.find(el => el.id === id);
        setActiveType(selectedType);
        setDefaultTitle(selectedType.title);
        props.changeTestType(selectedType.id);
        setIsOpen(false);
    }

    const handleOutsideClick = (e) => {
        const path = e.path || (e.composedPath && e.composedPath());
        if (!path.includes(selectRef.current)) {
            setIsOpen(false);
        }
    }

    useEffect(() => {
        const defaultActiveType = types.find(el => el.id === Number(props.testType));
        setDefaultTitle(defaultActiveType.title);
        document.body.addEventListener('click', handleOutsideClick);

        return () => {
            document.body.removeEventListener('click', handleOutsideClick);
        }
    }, [])

    return (
        <div ref={selectRef} className={`custom-select ${isOpen ? 'active': ''}`}>
            <div className="custom-select__field" onClick={() => setIsOpen(!isOpen)}>
                <span>{defaultTitle}</span>
                <svg className="custom-select__arrow" viewBox="0 0 24 24">
                    <path d="M12.409 15.823a.561.561 0 01-.818 0L5.149 8.924A.55.55 0 015.558 8h12.884a.55.55 0 01.41.924l-6.443 6.899z" fill="#262626"></path>
                </svg>
            </div>
            <div className="custom-select__list">
                {types.map((type) =>
                    <button
                       className={`custom-select__link ${activeType.id === type.id ? 'active' : ''}`}
                       onClick={(e) => setType(e, type.id)}
                       key={type.id}>
                        {type.title}
                    </button>
                )}
            </div>
        </div>
    )
}

export default Select;
